import React from 'react';
import { AccountVerificationProvider } from '../context/EWContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import EWStepper from '../components/EWStepper/EWStepper';

export default function Default(props) {
  const { eligibilityConfig } = props;

  return (
    <React.Fragment>
      <AccountVerificationProvider config={eligibilityConfig}>
        <GoogleReCaptchaProvider
          reCaptchaKey={eligibilityConfig.recaptcha?.siteKey}
        >
          <EWStepper></EWStepper>
        </GoogleReCaptchaProvider>
      </AccountVerificationProvider>
    </React.Fragment>
  );
};
